var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1998 7.0002C15.1998 10.4796 11.9763 13.3002 7.9998 13.3002C6.65733 13.3002 5.40067 12.9787 4.3249 12.4189L0.799805 13.3002L2.00428 10.4898C1.24333 9.49077 0.799805 8.2908 0.799805 7.0002C0.799805 3.5208 4.02335 0.700195 7.9998 0.700195C11.9763 0.700195 15.1998 3.5208 15.1998 7.0002ZM5.2998 6.1002H3.4998V7.9002H5.2998V6.1002ZM12.4998 6.1002H10.6998V7.9002H12.4998V6.1002ZM7.0998 6.1002H8.89981V7.9002H7.0998V6.1002Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.08dbb539cb40054224670e44f70c6418.svg";
export { ForwardRef as ReactComponent };